import { z } from 'zod';
import { bomInstructionDescriptionSchema, bomInstructionDetailsSchema, bomInstructionNameSchema, } from './instruction-form.js';
export const updateBomInstructionInputSchema = z.object({
    name: bomInstructionNameSchema.optional(),
    details: bomInstructionDetailsSchema,
    description: bomInstructionDescriptionSchema,
});
//# sourceMappingURL=update-instruction-input.js.map